<template>
    <div class="tops_body"
        :style="scrollPosition"
        :class="{ 'back_ground_control' : backGroundControl }"
    >
        <div v-if="(mobileAppHidden === true && showMypageBtn == true && loginState == true) || mobileAppHidden === false" class="tops_body__header">
            <span class='fullName'>{{ fullName }}</span>
            <div class="btnWrap" v-if="loginState == false">
                <button class='mypage-reserve-update-button' v-on:click='onLogin'>ログイン</button>
                <button class='mypage-reserve-update-button' v-on:click='onSignup'>新規会員登録はこちら</button>
            </div>
            <div class="header-content">
                <button v-if="showMypageBtn == false && loginState == true" class='mypage-reserve-update-button header-button' v-on:click='onLogout'>ログアウト</button>
                <button v-if="showMypageBtn == false && loginState == true" class='mypagebutton header-button' v-on:click='openMyPage'>マイページ</button>
                <button v-if="showMypageBtn == true && loginState == true" class='mypage-reserve-update-button' v-on:click='onMypage'>
                    <span class="mypage-update-button-text-pc">予約変更画面へ戻る</span>
                    <span class="mypage-update-button-text-sp">予約変更画面</span>
                </button>
            </div>
        </div>
        <div class="header_container">
            <div v-if="existImg == true" class="text-center">
                <img :src="imgPath" class='golf_course_img'/>
            </div>
        </div>
        <div class="start-time-body">
            <h3 class='golf-name-title'>
                <span>{{ plan_date }}</span>
                <span class="sp_block">{{ plan_name }}</span>
            </h3>
            <div>
                <h4 class='bg-single font-weight-bold text-center mb-4'>
                    スタート時間・人数選択
                    <small class='table_explanation' v-on:click="openModal">表の説明</small>
                </h4>
                <div v-if="cellChangeFlag == true && loginState == true" class="cell_UpNumber bg-single">
                    <div>※プレーをする枠を再度選択してください。</div>
                    <div class="d-flex pt-3 pb-1">
                        <div class="reserve_box"></div>
                        <div>：予約中の枠</div>
                    </div>
                </div>
                <ExplanationTableDialog v-show="showModal" v-on:from-TableDialog="closeModal"></ExplanationTableDialog>
            </div>
            <div class='table-back-ground'>
                <div class="scrollY w-100" @scroll="onScroll">
                    <table class="start-select-table-body">
                        <thead>
                        <tr align="center">
                            <th class="tableheader" width="210" rowspan="4">スタート時間</th>
                            <th class="tableheader" width="300" rowspan="4">コース</th>
                            <th class="tableheader" width="300" rowspan="4">人数</th>
                            <th class="tableheader sp_not" colspan="30">備考</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="info in course_time_info" :key="info.id" align="center"
                            v-show="(info.class === 'yes_reserve' && info.open === 1 && info.member_open === 0) ||
                                    (info.open === 0 && info.class === 'yes_reserve') ||
                                    (info.open !== 0 && info.member_open !== 0)"
                        >
                            <td :class="info.class">{{ info.start_time }}</td>
                            <td :class="info.class">{{ info.course_status }}</td>
                            <td v-if="info.count.length === 0" class="disabledCell">
                                -
                            </td>
                            <td v-else :class="info.class">
                                <div
                                    @mouseover="speechBalloonRendering(info, $event)"
                                    @mouseleave="clearSpeechBalloonCompanion"
                                    class="btn-group btn-group-toggle"
                                    data-toggle="buttons">
                                    <template v-for="(val, index) in info.count">
                                        <input
                                            :id="`${info.id}-${index + 1}`"
                                            :class="{ 'radio-inline__input': true }"
                                            type="radio"
                                            :name="`accessible-radio-${info.id}`"
                                            @click="selectNumber(info, index + 1, val, $event)"
                                            :key="`${info.id}-${index + 1}-1`"
                                            :disabled="disabledBtn(index + 1, info.least_num, info.max_num) || val.click_flag === '3' || val.name !== ''"
                                            :checked="val.click_flag == 1"
                                        />
                                        <label
                                            class="radio-inline__label"
                                            :for="`${info.id}-${index + 1}`"
                                            :key="`${info.id}-${index + 1}-2`"
                                            :class="{
                                                disabledCell:
                                                    disabledBtn(index + 1, info.least_num, info.max_num) || val.click_flag === '3'
                                            }">
                                    <span v-if="val.name === ''">
                                        {{ index + 1 }}
                                    </span>
                                        <span v-else-if="val.name !== ''">
                                        <div class="icon_reserve_human"></div>
                                    </span>
                                        </label>
                                    </template>
                                </div>
                            </td>
                            <td :class="info.class + ' sp_not'">
                                {{ info.remarks }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div v-if="player_info_speak_balloon == true"
                         class="pcview player-info-speech-balloon"
                         :style="speechBalloon">
                        <div class="container">
                            <div class="row align-items-center p-2" v-for="player_info in balloon_player_info" :key="player_info.id">
                                <div class="col-2">
                                    <span class='icon_registered'></span>
                                </div>
                                <div class="col-10 text-center">
                                    <div v-if="player_info.nickname" class="row p-1">
                                        {{ player_info.nickname }}
                                    </div>
                                    <div class="row p-1">
                                        {{ getPlayerInfoData(player_info.gender, player_info.age, player_info.score_level) }}
                                    </div>
                                    <div class="row p-1">
                                        {{ player_info.introduction }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="nrgFlag">
                <template v-if="requestApproval">
                    <div class="d-flex pt-sm-3 pt-3 justify-content-around flex-column flex-sm-row">
                        <div style="flex-grow: .6;"></div>
                        <div class="btn nextBtn mb-3" @click='onNext'>次　へ</div>
                        <div style="flex-grow: .5;"></div>
                        <div class="requestBtn mb-3" @click="gotoRequest">リクエスト予約</div>
                    </div>
                    <div class="d-flex pb-sm-3 justify-content-end flex-column flex-sm-row">
                        <div v-if="showMypageBtn == false" class="btn backBtn mb-3" @click='onBack'>戻る</div>
                    </div>
                </template>
                <template v-else>
                    <div class="d-flex pt-sm-3 pt-3 justify-content-around flex-column flex-sm-row">
                        <div style="flex-grow: .6;"></div>
                        <div class="btn nextBtn mb-3" @click='onNext'>次　へ</div>
                        <div style="flex-grow: .5;"></div>
                        <div v-if="showMypageBtn == false" class="btn backBtn mb-3" @click='onBack'>戻る</div>
                    </div>
                </template>
            </template>
            <div v-if="player_info_display == true" style="padding-bottom: 60px;" class="spview">
                <h5 class='font-weight-bold'>プレーヤー情報</h5>
                <div class='table-back-ground'>
                    <table class="planTableBody player-info-table">
                        <tr v-for="player_info in player_info" :key="player_info.id">
                            <td width='15%'><span class='icon_registered'></span></td>
                            <td style="text-align: center;">
                                <div v-if="player_info.nickname != '予約者'" >
                                    <template v-if="player_info.nickname">
                                        {{ player_info.nickname }}<br>
                                    </template>
                                    {{ player_info.gender }}<br>
                                    <template v-if="player_info.age">
                                        年齢：{{ player_info.age }}台<br>
                                    </template>
                                    <template v-if="player_info.score_level">
                                        スコアレベル：{{ player_info.score_level }}台
                                    </template>
                                </div>
                            </td>
                            <td>
                                {{ player_info.introduction }}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div>
                <h4 class='font-weight-bold text-center bg-single mt-3'>プラン詳細・料金</h4>
                <h5 class='font-weight-bold bg-single'>プラン詳細</h5>
                <div class='table-back-ground'>
                    <table class="plan-info-display-table">
                        <tr>
                            <td>プラン名</td>
                            <td>{{ course_detail_info.plan_name }}</td>
                        </tr>
                        <tr>
                            <td>ゴルフ場名</td>
                            <td>{{ course_detail_info.golf_course_name }}</td>
                        </tr>
                        <tr>
                            <td>プレー日</td>
                            <td>{{ course_detail_info.play_date }}</td>
                        </tr>
                        <tr>
                            <td>プレースタイル</td>
                            <!-- <td>{{ course_detail_info.play_style }}</td> -->
                            <td>
                                <span v-for="icon in iconFlag" :key="icon.id">
                                    <div class="play-style-icon" :class="icon.class"></div>
                                </span>
                            </td>
                        </tr>
                        <tr class="lastColumn">
                            <td valign="top">プラン詳細</td>
                            <td valign="top" style='white-space: pre-line;'>{{ course_detail_info.plan_detail }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="my-2">
                <h5 class='font-weight-bold bg-single'>料金</h5>
                <div class='table-back-ground'>
                    <table class="plan-info-display-table">
                        <tr>
                            <td>お一人様</td>
                            <td colspan="2"><span class="total-amount">￥{{ course_detail_fee.one }}</span><span> (総額)</span></td>
                        </tr>
                        <!-- <tr>
                            <td rowspan="3" valign="top">人数割増料金</td>
                            <td class="width-140">４バッグ</td>
                            <td>{{ formatedSumUpFee[2] }}</td>
                        </tr> -->
                        <tr>
                            <td class="width-140">３バッグ割増</td>
                            <td class="extra-charge">{{ formatedSumUpFee[1] }}</td>
                        </tr>
                        <tr>
                            <td class="width-140">２バッグ割増</td>
                            <td class="extra-charge">{{ formatedSumUpFee[0] }}</td>
                        </tr>
                        <tr class="lastColumn">
                            <td valign="top">キャンセル</td>
                            <td colspan="2" valign="top" style='white-space: pre-line;'>{{ course_detail_fee.cancel }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <template v-if="requestApproval">
                <div class="d-flex pt-sm-3 pt-3 justify-content-around flex-column flex-sm-row">
                    <div style="flex-grow: .6;"></div>
                    <div class="btn nextBtn mb-3" @click='onNext'>次　へ</div>
                    <div style="flex-grow: .5;"></div>
                    <div class="requestBtn mb-3" @click="gotoRequest">リクエスト予約</div>
                </div>
                <div class="d-flex pb-sm-3 justify-content-end flex-column flex-sm-row">
                    <div v-if="showMypageBtn == false" class="btn backBtn mb-3" @click='onBack'>戻る</div>
                </div>
            </template>
            <template v-else>
                <div class="d-flex pt-sm-3 pt-3 justify-content-around flex-column flex-sm-row">
                    <div style="flex-grow: .6;"></div>
                    <div class="btn nextBtn mb-3" @click='onNext'>次　へ</div>
                    <div style="flex-grow: .5;"></div>
                    <div v-if="showMypageBtn == false" class="btn backBtn mb-3" @click='onBack'>戻る</div>
                </div>
            </template>
        </div>
        <ErrorWordingDialogModal
            v-show="showError"
            v-bind:errorWording="errorMessage"
            v-on:closeErrorDialog="CloseErrorDialog"
        ></ErrorWordingDialogModal>
        <StartTimeConfirmDialog v-if="confirmFlag === true"
            initialMessage="予約枠変更時、既に組合せ登録をされている場合は再度設定し直しとなる為、ご注意ください。"
            doing="次へ"
            notDoing="戻る"
            :processing="processing"
            @from-Dialog="onConfirmMessageYes"
            @closeBtn="onConfirmMessageNo"
        />
    </div>
</template>

<script>
import ReserveHeader from './ReserveHeader';
import ExplanationTableDialog from './dialog/ExplanationTableDialog';
import ErrorWordingDialogModal from '../components/ErrorDialog';
import StartTimeConfirmDialog from '../components/StartTimeConfirmDialog';
import { GET_START_TIME_INITIALIZED_DATA } from '../../constants/plan_master';
import { GET_COMPANION_LIST } from '../../constants/companion';
import { MEMBER_LOG_OUT } from "../../constants/signout";
import { GET_MEMBER_ID, RESERVE_LOGIN_AT_LINE } from '../../constants/signin';
import { GET_CELL_STATUS } from '../../constants/cell_infos';
import { CODE_MASTER } from '../../config';
import { utilityMixin } from '../../mixins/utility';
import { modalMixin } from '../../mixins/modal';
import { GET_RESERVE } from '../../constants/mypage_reserves';
import { createApollo } from '../../lib/apollo';
import { UPDATE_RESERVE_DETAIL } from '../../constants/reserve';

export default {
    components: {
        ReserveHeader,
        ExplanationTableDialog,
        ErrorWordingDialogModal,
        StartTimeConfirmDialog
    },
    mixins: [
        utilityMixin,
        modalMixin
    ],
    data () {
        return {
            showModal: false,
            selectDate: null,
            plan_date: null,
            plan_name: null,
            // ログイン状態
            loginState: false,
            // コース時間配列
            course_time_info: [{
                id:'1',                   // キー
                start_time: '7:49',       // スタート時間
                course_status: 'out',     // コース名
                least_num: '1',           // 選択不可人数（最小人数 - 1）
                max_num: '4',
                remarks: '',              // 備考
                member_open: '', // 会員区分公開フラグ（1 :公開 0 :非公開)
                open: '', // 公開フラグ（1 :公開 0 :非公開)
                class: 'no_reserve',
                count: [
                    {   id: '1',              // キー
                        name: '',             // シェア識別（空:通常　空以外:シェア済）
                        click_flag: '0'       // 内部用フラグ　0:未選択状態　1:選択状態　3:クリック不可
                    },
                    { id: '2', name: '', click_flag: '0' },
                    { id: '3', name: '', click_flag: '0' },
                    { id: '4', name: '', click_flag: '0' }
                 ],
            }],
            // tmp_time_info: [],
            // コース情報配列
            course_detail_info:{
                plan_name: '',
                golf_course_name: '',
                play_date: '',
                plan_detail: ''
            },
            // プレースタイルアイコン
            iconFlag: [],
            // コース料金オブジェクト
            course_detail_fee: {
                one:'',
                sum_up_fee: {
                    two:'0',
                    three: '0',
                    four: '0'
                },
                cancel: ''
            },
            selectNum: [],
            // courseList: [],
            // courseSort: '',
            reserve_type: false,
            player_info_display: false,
            player_info_speak_balloon: false,
            player_info: [
                {id:1,
                    nickname:'名前',                  // 名前
                    gender:'男性',                    // 性別
                    age:'50',                         // 年代
                    score_level:'90',                 // スコアレベル
                    introduction:'プロフィールの内容'},
            ],
            reserveData: {},
            loadingCount: 0,
            // エラーダイアログ表示フラグ
            showError: false,
            // エラーダイアログの文言
            errorMessage: null,
            showReturnBtn: true,
            showMypageBtn: false,
            cellChangeFlag: false,
            fullName: 'ゲスト さん  ',
            // 代表者が予約した枠リスト
            reservedCellList: [],
            groupInfo: null,
            reserveNo: '',
            speechBalloonCompanion: [],
            balloon_player_info: [],
            // 吹き出しのスタイル
            speechBalloon: {
                position: 'absolute',
                top: '200px',
                left: '79%',
                width: '19%'
            },
            // モーダル背景スクロール制御フラグ
            backGroundControl: false,
            existImg: false,
            imgPath: '',
            confirmFlag: false,
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            // モバイルアプリ非表示フラグ
            mobileAppHidden: false,
            // 南幌用判定フラグ
            nrgFlag: process.env.MIX_STYLE_NAME == 'nrg' ? true: false
        };
    },
    created () {
        this.initialize();
    },
    computed: {
        formatedSumUpFee () {
            return Object.values(this.course_detail_fee.sum_up_fee).map(el => el === '0' ? '割増なし' : `￥${el}（消費税込）`);
        },
        disabledBtn (current_num, min_num, max_num) {
            return function (current_num, min_num, max_num) {
                return !(current_num >= min_num && current_num <= max_num);
            }
        },
        /** ----------------------------------------------
         * 予約変更ではなく、通常予約でリクエスト許可フラグが１のものを表
         * ---------------------------------------------- */
        requestApproval () {
            return !(sessionStorage.getItem("MyPage.reserveNo") && sessionStorage.getItem('MyPage.returnBackUrl') == '/mypage-reserve-update')
                && this.reserveData.requestApproval === 1
                && this.reserveData.calendarReserveType === CODE_MASTER.RESERVE_TYPE_NORMAL;
        }
    },
    methods: {
        onScroll () {
            this.clearSpeechBalloonCompanion();
        },
        /** ----------------------------------------------
         * 吹き出しの表示
         * ---------------------------------------------- */
        speechBalloonRendering (info, e) {
            if (info.reserve_status === Number(CODE_MASTER.RESERVE_STATUS_SHARE_POSSIBLE)) {
                const tmp = this.speechBalloonCompanion.filter(el => el.cell_id === info.id);
                this.setSpeechBalloonCompanion(tmp[0]);
                this.speechBalloon.top = e.pageY - 10 + 'px';
                this.speechBalloon.left = e.pageX + 30 + 'px';
            } else {
                this.player_info_speak_balloon = false;
            }
        },
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.loadingCount = 0;
            this.$store.commit("loading/setIsLoading", true);

            // モバイルアプリか判断する
            if (this.$store.state.auth.mobileAppFlag) {
                // モバイルアプリの場合、遷移ボタンを非表示にする
                this.mobileAppHidden = true;
            }
            if (this.$route.query.code) {
                // LINEログイン画面から遷移した場合（ログイン画面から遷移した場合は初期状態とする）
                let url =
                    process.env.MIX_GRAPHQL_URI +
                    "graphql?code=" +
                    this.$route.query.code;
                const client = createApollo(url);
                localStorage.removeItem("web-token");

                this.$store.commit("loading/setIsLoading", true);

                await client
                    .query({
                        query: RESERVE_LOGIN_AT_LINE,
                        fetchPolicy: "no-cache",
                        variables: {
                            providerName: "line",
                            redirectName: "services.line.redirect_starttime",
                            golfCode: ""
                        }
                    })
                    .then(res => {
                        localStorage.setItem("web-token", res.data.reserveLoginUsingSocial.accessToken);
                        if (localStorage.getItem("line-link")) {
                            this.$router.push("/" + localStorage.getItem("line-link") + "?access_from_line=1");
                            localStorage.removeItem("line-link");
                        } else {
                            this.$router.push("/starttime");
                        }
                    })
                    .catch(error => {
                        this.line_login_err_msg_txt = this.$t("error.validation.lineLoginError");
                        this.line_login_error = true;
                        this.$store.commit("loading/setIsLoading", false);
                    });
                this.reserveData = JSON.parse(localStorage.getItem('Reserve.reserveData'));
                localStorage.removeItem("Reserve.reserveData");
                sessionStorage.removeItem('Reserve.prevUrl');
                localStorage.removeItem("Reserve.returnBackUrl");
            } else if (localStorage.getItem("Reserve.returnBackUrl")) {
                // if (localStorage.getItem("Reserve.returnBackUrl")) {
                // ログイン画面から遷移した場合（ログイン画面から遷移した場合は初期状態とする）
                if (localStorage.getItem('Reserve.reserveData')) {
                    this.reserveData = JSON.parse(localStorage.getItem('Reserve.reserveData'));
                } else {
                    this.reserveData = JSON.parse(sessionStorage.getItem('Reserve.reserveData'));
                }
                localStorage.removeItem("Reserve.reserveData");
                sessionStorage.removeItem('Reserve.prevUrl');
                localStorage.removeItem("Reserve.returnBackUrl");
            } else {
                if (sessionStorage.getItem('Reserve.groupInfo')) {
                    this.groupInfo = JSON.parse(sessionStorage.getItem('Reserve.groupInfo'));
                    this.reserveNo = sessionStorage.getItem("MyPage.reserveNo");
                    // 代表者が予約済みの枠一覧を作成する
                    for (let info of this.groupInfo) {
                        this.reservedCellList.push(info.cell_id);
                    }
                    this.cellChangeFlag = true;
                }

                // マイページから推移した予約変更の場合予約番号からプラン情報を取得する
                if (sessionStorage.getItem("MyPage.reserveNo") && sessionStorage.getItem('Reserve.clickPage') == '/mypage-reserve-update') {
                    await this.getReserve(sessionStorage.getItem("MyPage.reserveNo"));
                    this.reserveNo = sessionStorage.getItem("MyPage.reserveNo");
                    //this.showReturnBtn = false;
                    this.showMypageBtn = true;
                } else {
                    this.reserveData = JSON.parse(sessionStorage.getItem('Reserve.reserveData'));
                    if (this.reserveData.calendarReserveType != CODE_MASTER.RESERVE_TYPE_SHARE) {
                        sessionStorage.removeItem('Reserve.groupInfo');
                    }

                    if (sessionStorage.getItem('MyPage.returnBackUrl')) {
                        this.showMypageBtn = true;
                    }
                }
            }
            // リクエスト予約画面から戻った時のデータ取得処理
            if (this.reserveData.calendarReserveType === CODE_MASTER.RESERVE_TYPE_REQUEST &&
                sessionStorage.getItem('Reserve.prevUrl') === '/starttime') {
                sessionStorage.setItem('Reserve.prevUrl', "/reserve");
                this.reserveData.calendarReserveType = CODE_MASTER.RESERVE_TYPE_NORMAL;
            }
            this.selectDate = new Date(this.reserveData.calendarSelectDate);
            this.plan_date = this.getDateStrJapanese(this.selectDate) + '（' + this.getDayJapanese(this.selectDate) + '）';

            this.getInitializeData(this.reserveData.calendarPlanId, this.selectDate, this.reserveNo);


            // ログイン状態を確認
            let token = localStorage.getItem('web-token');
            if (token) {
                // 会員番号を取得（取得できない場合はログアウト状態）
                if (await this.getLoginMember()) {
                    this.loginState = true;
                }
            }

            // エラーで戻って来た場合
            if (sessionStorage.getItem("Reserve.error")) {
                // シェアの重複チェックでエラーの場合
                if (sessionStorage.getItem("Reserve.error") == "duplicate") {
                    this.showError = true;
                    this.errorMessage = "既に同一枠が予約されています。";
                }
                sessionStorage.removeItem("Reserve.error");
            }

            this.$store.commit("loading/setIsLoading", false);

        },
        /** ----------------------------------------------
         * 予約情報を取得
         * ---------------------------------------------- */
        getReserve: async function (reserveNo) {
            const res = await this.$apollo.query({
                query: GET_RESERVE,
                fetchPolicy: 'no-cache',
                variables: {
                    reserve_no: reserveNo
                }
            });
            const data = res.data.GetReserveDetail.Reserve;
            this.reserveData = {
                golfCode: data.golf_code,
                memberNo: data.member_no,
                calendarPlanId: data.plan_id,
                calendarSelectDate: data.play_date,
                calendarReserveType: data.reserve_type,
                myPageReserveNo: data.reserve_no
            };
        },
        /** ----------------------------------------------
         * 表の説明ボタン処理
         * 　表の説明ダイアログを表示する
         * ---------------------------------------------- */
        openModal () {
            this.showModal = true;
            this.backGroundControl = true;
            this.openModalScroll();
        },
        /** ----------------------------------------------
         * 表の説明ダイアログの閉じるボタン処理
         * 　表の説明ダイアログを非表示にする
         * ---------------------------------------------- */
        closeModal () {
            this.showModal = false;
            this.backGroundControl = false;
            this.closeModalScroll();
        },
        /** ----------------------------------------------
         * プラン枠取得
         * 　プランに対する枠を取得する
         * ---------------------------------------------- */
        getInitializeData (planId, targetDate, reserveNo) {
            const targetDateStr = this.getDateStr(targetDate);

            this.loadingOn();
            // プラン枠検索
            this.$apollo.query({
                query: GET_START_TIME_INITIALIZED_DATA,
                fetchPolicy: 'no-cache',
                variables: {
                    plan_id: planId,
                    play_date: targetDateStr,
                    reserve_no: reserveNo
                }
            }).then(res => {
                this.setCourseTimeInfo(res.data.getStartTimeInitializedData.StartTimeList);
                this.getReserveData();
                this.setPlanDetail(
                    res.data.getStartTimeInitializedData.PlanCellInf,
                    res.data.getStartTimeInitializedData.AllSettingDays
                );
                // 吹き出し同伴者情報
                this.speechBalloonCompanion = res.data.getStartTimeInitializedData.CompanionListPlayDate;
                if (res.data.getStartTimeInitializedData.golf_course_img_path) {
                    this.imgPath = res.data.getStartTimeInitializedData.golf_course_img_path;
                    this.existImg = true;
                }
            }).catch(error => {
                const message = error.message.split(':');
                this.$store.commit("loading/setIsLoading", false);
            });

        },

        getOldGroupInfo () {
            // 変更前のセル情報を取得する。
            const oldGroupInfo = JSON.parse(sessionStorage.getItem('Reserve.groupInfo'));
            for (let i of oldGroupInfo) {
                oldCellIdInfoList.push({cellId: i.cell_id, number: i.player_number});
            };
            return oldCellIdInfoList;
        },
        /** ----------------------------------------------
         * 枠の表示設定
         * 　
         * ---------------------------------------------- */
        setCourseTimeInfo (startTimeList) {
            // 変更の場合
            let oldCellIdInfoList = [];
            if (sessionStorage.getItem('Reserve.groupInfo')) {
                // 変更前のセル情報を取得する。
                const oldGroupInfo = JSON.parse(sessionStorage.getItem('Reserve.groupInfo'));
                for (let j of oldGroupInfo) {
                    oldCellIdInfoList.push({cellId: j.cell_id, number: j.player_number});
                };
            }
            this.course_time_info = [];
            startTimeList.forEach(list => {
                // 予約者の会員区分とプラン区分を比較し、枠選択に制限をかける
                let memberClass = sessionStorage.getItem('MyPage.memberClass');
                let memberOpen = '';
                let planMemberClass = list.plan_member_class_code;

                if (memberClass) {
                    if (planMemberClass.charAt(memberClass) === '1') {
                        memberOpen = 1;
                    } else {
                        memberOpen = 0;
                    };
                }

                let listItem = {};
                listItem['id'] = list.cell_id;
                listItem['start_time'] = this.getTimeStr(list.play_start);
                listItem['course_status'] = list.course_name;
                listItem['least_num'] = list.player_min;
                listItem['max_num'] = list.player_max;
                listItem['member_open'] = memberOpen;
                listItem['open'] = list.open_flag;
                listItem['remarks'] = '';
                listItem['class'] = 'no_reserve';
                listItem['reserve_status'] = list.reserve_status;

                let numberList = [];
                let calReserve = 0;
                // シェア予約可能枠の場合
                if (list.reserve_status == CODE_MASTER.RESERVE_STATUS_SHARE_POSSIBLE) {
                    let player_number = 0;
                    // 予約された時の人数
                    let oldReservePlayer = 0;
                    // シェア枠は通常プランに表示させない
                    calReserve = 1;
                    // 変更の場合
                    if (sessionStorage.getItem('Reserve.groupInfo')) {
                        const cell = oldCellIdInfoList.findIndex(obj => obj.cellId === Number(list.cell_id));
                        if (cell !== -1) {
                            player_number = oldCellIdInfoList[cell].number;
                            oldReservePlayer = oldCellIdInfoList[cell].number;
                        }
                    }
                    for (let i = 0 ; i < 4 ; i++) {
                        let numberInf = {};
                        numberInf['id'] = i + 1;
                        numberInf['click_flag'] = '0';
                        // 変更の際に,元の予約で選択したセルはクリック可能にする。
                        if (player_number !== 0) {
                            numberInf['name'] = '';
                            numberInf['click_flag'] = '0';
                            // 変更する予約で確保した座席数を減算して、シェア予約の残席数に加算する
                            player_number--;
                            list.player_left++;
                            // 元の予約で選択したセルをチェック状態にする。
                            if (oldReservePlayer === numberInf['id']) {
                                numberInf['click_flag'] = '1';
                                /** ----------------------------------------------------------------------------------------------------------------------------
                                 * 枠の表示を切り替えるためのフラグをセットする
                                 * click_flag: 0 未選択状態 1 選択状態 3 クリック不可
                                 * id: 人数に表示される枠の番号
                                 * name: いずれかの予約で確保された枠のidがセットされる。変更する予約で確保された枠の時は枠のidをセットしない。cell_idが入っている。
                                 * --------------------------------------------------------------------------------------------------------------------------- */
                                this.selectNum.push({
                                    id: list.cell_id,
                                    number: {
                                        click_flag: "1",
                                        id: numberInf['id'],
                                        name: ""
                                    }
                                });
                            }
                            // 組を追加から遷移した場合、選択した時間は選択不可にする
                            if (sessionStorage.getItem('Reserve.cellAdd')) {
                                numberInf['click_flag'] = '3';
                            }
                            numberList.push(numberInf);
                            continue;
                        }
                        if (oldReservePlayer !== 0) {
                            // 組を追加から遷移した場合、選択した時間は選択不可にする
                            if (sessionStorage.getItem('Reserve.cellAdd')) {
                                numberInf['click_flag'] = '3';
                            }
                        }
                        // nameにidがセットされると人のアイコンに変わる為、ブランクで表示を切り替える
                        // 最大予約人数を超える枠番号はグレーの番号を表示（クリック不可）
                        if (i >= list.player_max) {
                            numberInf['name'] = '';
                        // 残席数はプラン毎に変わる最大予約人数に合わせる為、減算する
                        // 残席数以下の枠番号は選択可能
                        } else if (i < (list.player_left - (4 - list.player_max))) {
                            numberInf['name'] = '';
                        } else {
                            numberInf['name'] = list.cell_id;
                        }
                        numberList.push(numberInf);
                    }
                    if (list.reserve_no == this.reserveNo){
                        listItem['class'] = 'yes_reserve';
                        listItem['remarks'] = '予約中';
                    }
                    // 通常予約可能の場合
                } else if (list.reserve_status == CODE_MASTER.RESERVE_STATUS_POSSIBLE) {
                    for (let i = 1 ; i <= 4 ; i++) {
                        if (list.player_left >= i) {
                            let numberInf = {
                                'id': i,
                                'name': '',
                                'click_flag': '0'
                            };
                            numberList.push(numberInf);
                        } else {
                            let numberInf = {
                                'id': i,
                                'name': '',
                                'click_flag': '3'
                            };
                            // click_flagが3ならクリック不可
                            numberList.push(numberInf);
                        }
                    }
                    // 予約済み
                } else {
                    // 変更画面からの遷移で自分の予約の場合
                    if (list.reserve_no == this.reserveNo){
                        var number = null;
                        for (let info of this.groupInfo) {
                            if (Number(list.cell_id) === info.cell_id) {
                                number = info.player_number;
                            }
                        }
                        for (var i = 0; i < 4; i++) {
                            var numberInf = {};
                            numberInf['id'] = i + 1;
                            numberInf['name'] = '';
                            numberInf['click_flag'] = '0';
                            if (numberInf['id'] === number) {
                                numberInf['click_flag'] = '1';
                                this.selectNum.push({
                                    id: list.cell_id,
                                    number: {
                                        click_flag: "1",
                                        id: numberInf['id'],
                                        name: ""
                                    }
                                });
                            }
                            // 組を追加から遷移した場合、選択した時間は選択不可にする
                            if (sessionStorage.getItem('Reserve.cellAdd')) {
                                numberInf.click_flag = '3';
                            }
                            numberList.push(numberInf);
                            listItem['class'] = 'yes_reserve';
                            listItem['remarks'] = '予約中';
                        }
                    } else {
                        // 通常の予約済みはグレーにする
                        listItem['least_num'] = 5;

                        for (var i = 0 ; i < 4 ; i++) {
                            var numberInf = {};
                            numberInf['id'] = i + 1;
                            numberInf['name'] = '0';    // 人のアイコンにする
                            numberInf['click_flag'] = '0';
                            numberList.push(numberInf);
                        }
                    }
                }

                listItem['count'] = numberList;

                // 変更画面からの遷移で自分の予約 以外の場合
                if (list.reserve_no !== this.reserveNo){
                    // 9:削除済 もしくは 3:他サイトで予約済の場合
                    if (list.reserve_status == CODE_MASTER.RESERVE_STATUS_DELETED || list.reserve_status == CODE_MASTER.RESERVE_STATUS_OTHER_RESERVED) {
                        // スキップ
                        return;
                    }

                    // 保証なしプランの場合
                    if(Number(this.reserveData.calendarReserveType) === Number(CODE_MASTER.RESERVE_TYPE_SHARE)){
                        // 0:WEB予約済み  もしくは  1:通常予約可能の場合
                        if (list.reserve_status == CODE_MASTER.RESERVE_STATUS_WEB_RESERVED || list.reserve_status == CODE_MASTER.RESERVE_STATUS_POSSIBLE) {
                            // スキップ
                            return;
                        }
                    }

                    // 保証ありプランの場合
                    if(Number(this.reserveData.calendarReserveType) === Number(CODE_MASTER.RESERVE_TYPE_NORMAL)){
                        // 2:シェア予約可能枠で 1人でも予約があったら場合
                        if (list.reserve_status == CODE_MASTER.RESERVE_STATUS_SHARE_POSSIBLE && list.player_left < list.player_max){
                            // グレーにする
                            // listItem['least_num'] = 5;
                            // 予約不可能な枠のため非表示 2022-03-28
                            return;
                        }
                    }
                }

                // 通常予約でシェア枠に予約が入ってる場合表示しない。 ※上のifで制御するため不要
                //if (!(Number(this.reserveData.calendarReserveType) === 1 && calReserve === 1)) {
                    this.course_time_info.push(listItem);
                //}
            });

        },
        /** ------------------------------------------------------------------------
         * 選択済データ取得処理　
         * ------------------------------------------------------------------------- */
        getReserveData: function () {
            if (!sessionStorage.getItem('Reserve.prevUrl')){
                return;
            }

            if (sessionStorage.getItem('Reserve.groupInfo')){
                return;
            }

            // 自画面への戻りではない場合
            if (sessionStorage.getItem('Reserve.prevUrl') != "/starttime") {
                return;
            }
            sessionStorage.removeItem('Reserve.prevUrl');

            var cellIdInfoList = this.reserveData.selectCellId;
            this.selectNum = [];
            for (var i = 0 ; i < cellIdInfoList.length ; i++) {
                const idx = this.course_time_info.findIndex(el => el.id === cellIdInfoList[i].cellId);
                const numIdx = cellIdInfoList[i].number - 1;
                this.course_time_info[idx].count[numIdx].click_flag = '1';

                const obj = {
                    id: cellIdInfoList[i].cellId,
                    number: this.course_time_info[idx].count[numIdx]
                };
                this.selectNum.push(obj);

            }
        },

        /** ----------------------------------------------
         * プランの詳細設定
         * ---------------------------------------------- */
        setPlanDetail (planDetail, allSettingDay) {
            this.plan_name = planDetail.plan_name;
            this.course_detail_info['plan_name'] = planDetail.plan_name;
            this.course_detail_info['golf_course_name'] = planDetail.golf_name;
            this.course_detail_info['play_date'] = this.plan_date;
            this.course_detail_info['plan_detail'] = planDetail.detail;

            // プレースタイル設定
            this.iconFlag = [];
            if (planDetail.meal_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 1, class: planDetail.meal_flag_icon });
            }
            this.iconFlag.push({ id: 2, class: planDetail.cart_code_icon });
            this.iconFlag.push({ id: 3, class: planDetail.guarantee_code_icon });
            if (planDetail.caddie_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 4, class: planDetail.caddie_flag_icon });
            }
            this.iconFlag.push({ id: 5, class: planDetail.round_code_icon });
            if (planDetail.accommodation_flag !== CODE_MASTER.NOT_USE_SETTING) {
                this.iconFlag.push({ id: 6, class: planDetail.accommodation_flag_icon });
            }
            this.iconFlag.push({ id: 7, class: planDetail.share_flag_icon });

            this.course_detail_fee['one'] = planDetail.total_fee.toLocaleString();
            this.course_detail_fee['cancel'] = planDetail.cancel_detail;
            // 対象日が土日祝の場合
            if (this.judgeDay(new Date(this.selectDate), allSettingDay) > 0) {
                this.course_detail_fee['sum_up_fee']['two'] = planDetail.add_fee_2b_weekend.toLocaleString();
                this.course_detail_fee['sum_up_fee']['three'] = planDetail.add_fee_3b_weekend.toLocaleString();
                this.course_detail_fee['sum_up_fee']['four'] = "0";
            } else {
                this.course_detail_fee['sum_up_fee']['two'] = planDetail.add_fee_2b_weekday.toLocaleString();
                this.course_detail_fee['sum_up_fee']['three'] = planDetail.add_fee_3b_weekday.toLocaleString();
                this.course_detail_fee['sum_up_fee']['four'] = "0";
            }
        },

        /** ----------------------------------------------
         * 枠人数選択処理
         * ---------------------------------------------- */
        selectNumber (info, index, val, el) {
            if (val.click_flag === '1') {
                val.click_flag = '0';
                if (el.target.checked === true) {
                    el.target.checked = false;
                }
            } else {
                for (var i = 0; i < info.count.length; i++) {
                    if (info.count[i].click_flag === '1') {
                        info.count[i].click_flag = '0';
                    }
                }
                val.click_flag = '1';
            }
            // シェア予約時の場合、ボタンをクリックしたらプロフィール画面の表示をする
            if ( val.name !='' ) {
                this.getPlayerInfo(val.name);
            } else {
                this.player_info_display = false;
            }
            const obj = {
                id: info.id,
                number: val
            };
            // すでに同じ枠idのものが存在するとき、すでに存在するものを削除する
            const key = this.selectNum.findIndex(el => el.id === info.id);
            if (key  !== -1) {
                this.selectNum.splice(key, 1);
            }
            // チェックをONにした場合
            if (val.click_flag == '1'){
                this.selectNum.push(obj);
            }
        },
        /** ----------------------------------------------
         * プレーヤ情報取得
         * 　シェア枠のプレーヤ情報を取得する
         * @param {String} cellId 枠ID
         * ---------------------------------------------- */
        getPlayerInfo (cellId) {
            this.$apollo.query({
                query: GET_COMPANION_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    cell_id: cellId,
                    reserve_no: null
                }
            }).then(res => {
                var playerList = res.data.GetCompanionList.CompanionLists;
                this.player_info = [];
                playerList.forEach(list => {
                    var listItem = {};
                    listItem['id'] = list.member_no;
                    listItem['nickname'] = list.nickname;
                    if (list.gender == 0) {
                        listItem['gender'] = '男性';
                    } else {
                        listItem['gender'] = '女性';
                    }
                    listItem['age'] = list.era;
                    listItem['score_level'] = list.score_level;
                    listItem['introduction'] = '';
                    if (list.profile != null) {
                        listItem['introduction'] = list.profile;
                    }
                    if (list.enthusiasm != null) {
                        listItem['introduction'] = listItem['introduction'] + "\n" + list.enthusiasm;
                    }

                    this.player_info.push(listItem);
                });
                // 不明者の作成
                for (var i = playerList.length; i < playerList[0].player_num; i++) {
                    var listItem = {};
                    listItem['id'] = 100000000000000000000 + i;
                    listItem['nickname'] = '予約者';
                    listItem['gender'] = '';
                    listItem['age'] = '';
                    listItem['score_level'] = '';
                    listItem['introduction'] = '';
                    this.player_info.push(listItem);
                }

                if (playerList.length != 0) {
                    this.player_info_display = true;
                }
            }).catch(error => {
                const message = error.message.split(':');
            });
        },
        /** ----------------------------------------------
         * 吹き出し表示 データセット
         * ---------------------------------------------- */
        setSpeechBalloonCompanion (playerList) {
            this.balloon_player_info = [];
            if (!playerList) {
                return;
            }
            playerList['Companion'].forEach(list => {
                let listItem = {
                    id: list.cell_id + '-' + list.player_no,
                    nickname: list.nickname,
                    gender: list.gender == 0 ? '男性' : '女性',
                    age: list.era,
                    score_level: list.score_level,
                    introduction: ''
                };
                if (list.profile != null) {
                    listItem['introduction'] = list.profile;
                }
                if (list.enthusiasm != null) {
                    listItem['introduction'] = listItem['introduction'] + "\n" + list.enthusiasm;
                }
                this.balloon_player_info.push(listItem);
            });
            this.player_info_speak_balloon = true;
        },
        /** ----------------------------------------------
         * 吹き出し表示 初期化
         * ---------------------------------------------- */
        clearSpeechBalloonCompanion () {
            this.balloon_player_info = [];
            this.player_info_speak_balloon = false;
        },
        /** ----------------------------------------------
         * 戻るボタン処理処理
         * ---------------------------------------------- */
        onBack() {
            if (sessionStorage.getItem('MyPage.returnBackUrl')) {
                // 組数追加（同伴者登録より遷移）の場合
                if (sessionStorage.getItem('Reserve.groupInfo') && this.loginState == true) {
                    sessionStorage.removeItem('Reserve.groupInfo');
                    this.$router.push({ path: "/registcompanion" });
                    return;
                } else {
                    this.$router.push({ path: sessionStorage.getItem('MyPage.returnBackUrl') });
                    sessionStorage.removeItem('MyPage.returnBackUrl');
                    return;
                }
            }
            sessionStorage.removeItem('Reserve.reserveNo');
            sessionStorage.setItem('Reserve.prevUrl', "/reserve");
            sessionStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
            this.$router.push("/reserve");
        },
        /** ----------------------------------------------
         * マイページへ処理処理
         * 　
         * ---------------------------------------------- */
        onMypage() {
            this.$router.push('/mypage-reserve-update');
        },
        /** ----------------------------------------------
         * 次へボタン処理処理
         * 　
         * ---------------------------------------------- */
        onNext() {
            if (this.selectNum.length == 0) {
                this.showError = true;
                this.errorMessage = 'スタート時間が選択されていません。'
                return;
            }

            // 現在のセル情報を取得する。
            let cellIdList = [];
            let cellIdInfoList = [];
            this.selectNum.forEach(select => {
                cellIdInfoList.push({cellId: select.id, number: select.number.id});
                cellIdList.push(select.id);
            });
            this.cellInfo = cellIdInfoList;

            // 選択枠が予約済みでないか再確認
            let me = this;
            this.$apollo.query({
                query: GET_CELL_STATUS,
                fetchPolicy: 'no-cache',
                variables: {
                    cell_id: cellIdList
                }
            }).then(res => {
                // 枠状態を確認する
                if (me.checkCellStatus(res.data.GetCellStatus.CellStatusList, cellIdInfoList) == true) {
                    me.reserveData['selectCellId'] = cellIdInfoList;
                    let reserveData = me.reserveData;
                    // 組数変更の場合（組数を増やす場合予約済みの情報をpushする。）

                    // sessionStorage.getItem('MyPage.companionChangeFlg')が3のときは同伴者情報のcell_idをnullにして、
                    // 同伴者リストに既に登録されている同伴者が表示される状態
                    if (sessionStorage.getItem('Reserve.groupInfo')
                        && me.loginState === true
                        && Number(sessionStorage.getItem('MyPage.companionChangeFlg')) !== 3) {
                        /*** 同伴者画面からの画面遷移の為、ログイン済であるためlocalStorageには情報を保存しない ***/
                        // 組数が変わっていない場合（シェアの時は予約済み件数がselectNumに設定されていない）

                        // 20201211 シェアの時もselectNumに設定するように修正したため、以下のif文をコメントアウト
                        // if (this.reserveData.calendarReserveType == CODE_MASTER.RESERVE_TYPE_NORMAL) {
                        if (me.selectNum.length == Number(sessionStorage.getItem('Reserve.cellNumber'))) {
                            me.showError = true;
                            me.errorMessage = '追加するスタート時間が選択されていません。'
                        } else {
                            // 予約詳細追加
                            me.AddReserveDetail(cellIdInfoList);
                        }
                    } else {
                        // 予約変更時、組み合わせがリセットされる旨の確認メッセージ表示
                        if (sessionStorage.getItem('MyPage.returnBackUrl') == '/mypage-reserve-update') {
                            this.confirmFlag = true;
                        } else {
                            // ログインしていない場合のログイン画面からの遷移URL（確認画面）をセット
                            localStorage.setItem("Reserve.returnBackUrl", "/reservecontent");
                            // ログインしていない場合があるためlocalStorageに設定
                            localStorage.setItem('Reserve.reserveData', JSON.stringify(reserveData));
                            me.$store.commit('auth/setLineOperationTypeFlag', 'starttime');
                            // 未ログイン時はここでログイン画面へ遷移
                            if (this.loginState == false) {
                                this.$router.push('/?gc=' + reserveData.golfCode);
                            } else {
                                // 確認画面表示
                                me.$router.push("/reservecontent");
                            }
                        }
                    }
                } else {
                    me.showError = true;
                    me.errorMessage = '他の方が既に予約されたため予約できません。\n もう一度プランの選択から予約してください。'
                }
            }).catch(error => {
                const message = error.message.split(':');
            });
        },
        gotoRequest () {
            this.reserveData.calendarReserveType = CODE_MASTER.RESERVE_TYPE_REQUEST;
            sessionStorage.setItem('Reserve.prevUrl', '/starttime');
            sessionStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
            this.$router.push("/requesttimeselect");
        },
        getPlayerInfoData (gender, age = '', score = '') {
            return gender + ' '
                + (age ? age + '代 ' : '')
                + (score ? 'スコア:' + score + '台' : '');
        },
        /** ----------------------------------------------
         * 枠状態チェック
         * @param {array} cellStatusList 枠状態
         * @param {array} cellIdInfoList 枠選択情報（cellId: 枠ID, number: 人数）
         * ---------------------------------------------- */
        checkCellStatus(cellStatusList, cellIdInfoList) {
            var checkStatus = true;
            var checkStatusList = []

            // 変更の場合
            let oldCellIdInfoList = [];
            if (sessionStorage.getItem('Reserve.groupInfo')) {
                // 変更前のセル情報を取得する。
                const oldGroupInfo = JSON.parse(sessionStorage.getItem('Reserve.groupInfo'));
                for (let j of oldGroupInfo) {
                    oldCellIdInfoList.push({cellId: j.cell_id, number: j.player_number});
                };
            }

            // 通常予約の場合
            if (this.reserveData.calendarReserveType == CODE_MASTER.RESERVE_TYPE_NORMAL) {
                cellStatusList.forEach(cellStatus => {
                    // 枠がシェア予約可能でinfoとlinkで残席数が違った場合
                    if (cellStatus.reserve_status == CODE_MASTER.RESERVE_STATUS_SHARE_POSSIBLE && cellStatus.player_left != cellStatus.link_player_left) {
                        checkStatus = false;
                    }
                    if (sessionStorage.getItem('Reserve.groupInfo')) {
                        // 既に予約をしていた枠は除外
                        if (this.reservedCellList.includes(Number(cellStatus.cell_id))) {
                            checkStatus = true;
                        }
                    }
                    checkStatusList.push(checkStatus);
                });
                // シェア予約の場合
            } else if (this.reserveData.calendarReserveType == CODE_MASTER.RESERVE_TYPE_SHARE) {
                cellStatusList.forEach(cellStatus => {
                    cellIdInfoList.forEach(selectInfo => {
                        let num = 0;
                        // 変更の場合
                        if (sessionStorage.getItem('Reserve.groupInfo')) {
                            const cell = oldCellIdInfoList.findIndex(obj => obj.cellId === Number(cellStatus.cell_id));
                            if (cell !== -1) {
                                num = oldCellIdInfoList[cell].number;
                                // list.player_left + oldPlayerNumber[cell];
                            }
                        }
                        if (cellStatus.cell_id == selectInfo.cellId) {
                            // シェア予約可能で予約可能席数が選択人数より多い場合
                            if (cellStatus.reserve_status == CODE_MASTER.RESERVE_STATUS_POSSIBLE ||
                                cellStatus.reserve_status == CODE_MASTER.RESERVE_STATUS_SHARE_POSSIBLE) {
                                if (num !== -1) {
                                    cellStatus.player_left += num;
                                }
                                if (cellStatus.player_left >= selectInfo.number) {
                                } else {
                                    checkStatus = false;
                                }
                            } else {
                                checkStatus = false;
                            }
                        }
                    });
                });
            }
            if (sessionStorage.getItem('Reserve.groupInfo')) {
                // 組の変更時にすでにcheckStatusListに一つでもfalseがあればcheckStatusをfalseにする
                if (checkStatusList.includes(false)){
                    checkStatus = false;
                }
            }

            return checkStatus;
        },
        /** ----------------------------------------------
         * 予約詳細追加
         * 　追加組に対する予約詳細を追加する。
         * 　同伴者登録画面より遷移し、組追加を行うため履歴は作らない。（履歴は同伴者登録でカウントアップ）
         * @param {array} cellIdInfoList 枠選択情報（cellId: 枠ID, number: 人数）
         * ---------------------------------------------- */
        async AddReserveDetail(cellIdInfoList) {
            // 既に予約されている枠を取得（同伴者登録を経てMyPageより）
            var reservedCell = [];
            var reservePlayerNumber = 0;    // 変更前予約人数
            if (sessionStorage.getItem('Reserve.groupInfo')) {
                var groupInfo = JSON.parse(sessionStorage.getItem('Reserve.groupInfo'));
                for (let info of groupInfo) {
                    reservedCell.push(info.cell_id);
                    reservePlayerNumber = reservePlayerNumber + info.player_number;
                }
            }
            cellIdInfoList.forEach(cells => {
                // 予約済枠以外の場合、変更前予約人数に追加された人数を加算する
                if (!reservedCell.includes(Number(cells.cellId))) {
                    reservePlayerNumber = reservePlayerNumber + cells.number;
                }
            });

            // ＤＢ更新情報を作成する
            var addCell = [];
            cellIdInfoList.forEach(cells => {
                // 予約済枠以外の場合
                if (!reservedCell.includes(Number(cells.cellId))) {
                    addCell.push({reserve_no: this.reserveNo,
                        cell_id: Number(cells.cellId),
                        player_number: cells.number,
                        cell_number: cellIdInfoList.length,
                        reserve_player_number: reservePlayerNumber,
                        reserve_type: this.reserveData.calendarReserveType});
                }
            });

            await this.$apollo
                .mutate({
                    mutation: UPDATE_RESERVE_DETAIL,
                    variables: {
                        cellInfos: addCell,
                    }
                }).then(res => {
                    // 同伴者登録へ遷移
                    sessionStorage.removeItem('Reserve.groupInfo');
                    sessionStorage.removeItem('Reserve.cellAdd');
                    this.$router.push({ path: "/companion-list" });
                }).catch(error => {
                    this.error = error;
                });

        },
        /** ----------------------------------------------
         * メッセージ確認で「はい」押下
         * ---------------------------------------------- */
        onConfirmMessageYes: async function () {
            this.onConfirmMessageNo();
            // ログインしていない場合のログイン画面からの遷移URL（確認画面）をセット
            localStorage.setItem("Reserve.returnBackUrl", "/reservecontent");
            // ログインしていない場合があるためlocalStorageに設定
            localStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
            this.$store.commit('auth/setLineOperationTypeFlag', 'starttime');
            // 未ログイン時はここでログイン画面へ遷移
            if (this.loginState == false) {
                this.$router.push('/?gc=' + this.reserveData.golfCode);
            } else {
                // 確認画面表示
                this.$router.push("/reservecontent");
            }
        },
        /** ----------------------------------------------
         * メッセージ確認で「いいえ」押下
         * ---------------------------------------------- */
        onConfirmMessageNo: async function () {
          this.confirmFlag = false;
          this.$set(this.processing, 'result', '');
        },

        /** ----------------------------------------------
         * 会員番号処理
         * ---------------------------------------------- */
        async getLoginMember() {
            let res = await this.$apollo
                .query({
                    query: GET_MEMBER_ID,
                    fetchPolicy: 'no-cache'
                })
                .catch(error => {
                    this.error = error;
                });
            if (res) {
                this.reserveData.memberNo = res.data.getLoginMember.member_no;
                this.fullName = res.data.getLoginMember.family_name + ' ' + res.data.getLoginMember.given_name + ' さん ';
            } else {
                return false;
            }

            return true;
        },

        /** ----------------------------------------------
         * エラーダイアログを閉じる
         * ---------------------------------------------- */
        CloseErrorDialog () {
            this.showError = false;
        },

        /** ----------------------------------------------
         * ログイン画面表示処理
         * ---------------------------------------------- */
        onLogin () {
            // localStorageに一時退避
            localStorage.setItem("Reserve.returnBackUrl", "/starttime");
            localStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
            localStorage.setItem("Reserve.logInUrl", "/starttime");
            this.$store.commit('auth/setLineOperationTypeFlag', 'starttime');
            this.$router.push('/?gc=' + this.reserveData.golfCode);
        },
        /** ----------------------------------------------
         * 会員登録画面表示処理
         * ---------------------------------------------- */
        onSignup () {
            // localStorageに一時退避
            localStorage.setItem("Reserve.returnBackUrl", "/starttime");
            localStorage.setItem('Reserve.reserveData', JSON.stringify(this.reserveData));
            localStorage.setItem("Reserve.logInUrl", "/starttime");
            this.$store.commit('auth/setLineOperationTypeFlag', 'starttime');
            this.$router.push('/signup?gc=' + localStorage.getItem('Reserve.golfCode'));
        },
        /** ----------------------------------------------
         * ログオフ処理
         * ---------------------------------------------- */
        onLogout () {
            this.$store.commit("loading/setIsLoading", true);

            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.mutate({
                mutation: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.loginState = false;
                this.$store.commit("loading/setIsLoading", false);
                this.reserveData.memberNo = '';
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
            this.fullName = 'ゲスト さん  ';
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function () {
            this.loadingCount--;
            if (this.loadingCount <= 0) {
                this.$store.commit("loading/setIsLoading", false);
            }
        },

        /** ----------------------------------------------
         * 子コンポーネントの処理終了通知
         * @param {Boolean} status true:正常  false:異常
         * ---------------------------------------------- */
        onFinishedProc: function (status) {
            if (status) {
                this.loadingOff();
            } else {
                this.$store.commit("loading/setIsLoading", false);
            }
        },
        openMyPage() {
            this.$router.push('/mypage');
        }
    }
}

</script>

<style scoped>
table {
    width: 100%;
}
th{
    border: solid 1px #e8e8e8;
}
td{
    border: solid 1px #e8e8e8;
}
.return{
    text-decoration: underline;
    font-size: 1.2rem;
    margin-right: 5%;
    cursor: pointer;
    color: #207474;
}
.return:hover{
    color: blue;
}
.cell_UpNumber{
    font-size: 0.9rem;
    font-weight: normal;
    color: red;
}
.no_reserve{
    background-color: white;
}
.yes_reserve{
    background-color:#fcf5e7;
}
.reserve_box{
    width: 20px;
    height: 20px;
    border: solid 1px #e8e8e8;
    background-color: #fcf5e7;
}
.btnWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.icon_reserve_human {
    font-size: 35px;
    background-size: 30px;
    height: 30px;
    width: 39px;
}
.disabledCell{
  pointer-events: none;
}
@media screen and (max-width: 896px) {
    .start-select-table-body{
        font-size: 0.8rem;
    }
    .start-select-table-body ::v-deep th{
        padding: 5px;
    }
    .start-select-table-body ::v-deep td{
        font-size: 0.95rem;
    }
    .sp_block{
        display: block;
    }
    .icon_registered{
        background-size: 50px;
        height: 50px;
        width: 50px;
        margin: 0;
    }
}
@media screen and (max-width: 575px) {
    .width-140{
        width: initial;
    }
    .radio-inline__label {
        margin: 0 2px 0 0;
    }
}

</style>
